import React from 'react';
import { useAppDispatch } from 'src/store/hooks';
import { handleModalLogin } from 'src/store/actions/modal';
import RegisterForm from './RegisterForm';
import AuthImage from '../AuthImage';
import Container from 'src/components/reusable/Container';

interface RegisterProps {}

const Register: React.FC<RegisterProps> = ({}) => {
  const dispatch = useAppDispatch();

  const handleOpenLogin = () => {
    dispatch(handleModalLogin(true));
  };

  return (
    <Container>
      <div className="relative block lg:flex min-h-full gap-x-16 justify-center items-center">
        <div className="basis-2/5 z-50">
          <RegisterForm openLogin={handleOpenLogin} />
        </div>
        <div className="basis-3/5 hidden lg:flex">
          <AuthImage buttonText="Login" handleClick={handleOpenLogin} />
        </div>
      </div>
    </Container>
  );
};

export default Register;
